/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class CountryPlotApi extends runtime.BaseAPI {
    /**
     * Create Country Plot
     */
    async v2CreateCountryPlotRaw(requestParameters, initOverrides) {
        if (requestParameters['countryPlotCreate'] == null) {
            throw new runtime.RequiredError('countryPlotCreate', 'Required parameter "countryPlotCreate" was null or undefined when calling v2CreateCountryPlot().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/country-plot/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['countryPlotCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Country Plot
     */
    async v2CreateCountryPlot(requestParameters, initOverrides) {
        const response = await this.v2CreateCountryPlotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Country Plot
     */
    async v2DeleteCountryPlotRaw(requestParameters, initOverrides) {
        if (requestParameters['countryPlotId'] == null) {
            throw new runtime.RequiredError('countryPlotId', 'Required parameter "countryPlotId" was null or undefined when calling v2DeleteCountryPlot().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/country-plot/{country_plot_id}`;
        urlPath = urlPath.replace(`{${"country_plot_id"}}`, encodeURIComponent(String(requestParameters['countryPlotId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Delete Country Plot
     */
    async v2DeleteCountryPlot(requestParameters, initOverrides) {
        const response = await this.v2DeleteCountryPlotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Country Plot
     */
    async v2GetCountryPlotRaw(requestParameters, initOverrides) {
        if (requestParameters['countryPlotId'] == null) {
            throw new runtime.RequiredError('countryPlotId', 'Required parameter "countryPlotId" was null or undefined when calling v2GetCountryPlot().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/country-plot/{country_plot_id}`;
        urlPath = urlPath.replace(`{${"country_plot_id"}}`, encodeURIComponent(String(requestParameters['countryPlotId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Country Plot
     */
    async v2GetCountryPlot(requestParameters, initOverrides) {
        const response = await this.v2GetCountryPlotRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
